import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProgressComponent } from './simple-icons-progress.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProgressComponent ],
    exports:      [ SimpleIconsProgressComponent ],
    bootstrap:    []
})
export class SimpleIconsProgressModule {}
